const specialNewlineCharacter = "\u200b\u200b";

export function isTwoLineText(text: string): boolean {
  return (
    text.indexOf(specialNewlineCharacter) !== -1 || text.indexOf(" ") !== -1
  );
}
